module.exports = __webpack_public_path__ + "static/author-9950be076c24e392f82d3102fd454d09.png";